import { createReducer, on } from '@ngrx/store';

import { UserActions } from './actions';
import { IUserState, defaultUserState } from './state';

export const userReducer = createReducer(
    defaultUserState,
    on(
        UserActions.initState,
        (state, action): IUserState => ({
            isAuthenticated: action.state.isAuthenticated,
            bettingSettings: action.state.bettingSettings,
            configSettings: action.state.configSettings,
            walletLoaded: action.state.walletLoaded,
            oddsFormat: action.state.oddsFormat,
        }),
    ),
    on(
        UserActions.userLoggedIn,
        (state): IUserState => ({
            ...state,
            isAuthenticated: true,
        }),
    ),
    on(
        UserActions.userLoggedOut,
        (state): IUserState => ({
            ...state,
            isAuthenticated: false,
        }),
    ),
    on(
        UserActions.updateState,
        (state, action): IUserState => ({
            ...state,
            bettingSettings: action.settings,
            configSettings: action.config,
            oddsFormat: action.oddsFormat,
        }),
    ),
    on(UserActions.setWalletLoaded, (state, action): IUserState => ({ ...state, walletLoaded: action.walletLoaded })),
);
